import { connect } from "react-redux"

import Actions from "../../Actions/Creators"
import Support from "./Component/Support"
import Phi from "../../Phi/Phi"

const mapStateToProps = (state, ownProps) => {
    const userProfile = state.auth.userProfile

    return {
        userProfile
    }
}

const mapDispatchToProps = (dispatch) => ({
    sendSupportEmail: (template, recipient, variables, subject, sender) =>
        dispatch(Actions.sendEmail(template, recipient, variables, subject, sender)),
    makeSupportCall: (numberTo, numberFrom) => dispatch(Actions.makeCall(numberTo, numberFrom)),

    changeLocation: (location) => dispatch(Actions.changeCurrentLocation(location))
})

export default connect(mapStateToProps, mapDispatchToProps)(Support)
